export const SET_AUTH_PROGRESS = 'user/SET_AUTH_PROGRESS';
export const START_LOADING = 'user/START_LOADING';
export const STOP_LOADING = 'user/STOP_LOADING';
export const SET_USER = 'user/SET_USER';
export const SET_AD_GROUPS = 'user/SET_AD_GROUPS';
export const SET_USERS_LOADING = 'user/SET_USERS_LOADING';
export const SET_USERS = 'user/SET_USERS';
// export const SET_GROUPS_LOADING = 'user/SET_GROUPS_LOADING';
// export const SET_GROUPS = 'user/SET_GROUPS';
export const SET_CURRENT_USER_ADP_PERMISSION = 'user/SET_CURRENT_USER_ADP_PERMISSION';
export const UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE = 'user/UPDATE_CURRENT_USER_ADP_PERMISSION_DATA_LOADED_STATE';
export const SET_CONFIGURED_USERS = 'user/SET_CONFIGURED_USERS';
export const SET_CONFIGURED_USERS_LOADING = 'user/SET_CONFIGURED_USERS_LOADING';
export const SET_USERS_PERMISSIONS = 'user/SET_USERS_PERMISSIONS';